import { ThreadedCalculator } from './threaded-calculator';
import memoizeOne from 'memoize-one';
import { runJob } from './jobs';
import { functionsWithAPI } from './api-functions';
const loadWorker = memoizeOne((api) => new ThreadedCalculator(api));
export async function postJob(job, onError, api) {
    try {
        if (window.Worker) {
            const worker = loadWorker(api);
            return await worker.postJob(job);
        }
        else {
            return await runJob(job, {
                post: functionsWithAPI(api), //api
            });
        }
    }
    catch (e) {
        onError(e);
        throw e;
    }
}
